<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="p-3" v-if="invoice">
      <InvoiceDetailsTable :invoice="invoice"></InvoiceDetailsTable>

      <div>
        <h5 class="mt-5 text-center text-capitalize-first">
          {{ helper.trans("labels.invoice_deals")}}
        </h5>
        <InvoiceDealDetailsTable :deals="deals.items"></InvoiceDealDetailsTable>
      </div>


    </div>

  </LoaderWrapper>
</template>

<script lang="ts">

import {defineComponent, PropType, Prop, watch, ref} from 'vue'
import {helper} from "@/service/CommonHelper";
import {reactive, toRefs} from "@vue/reactivity";
import APIClient from "@/service/APIClient";
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import CopyButton from "@/components/CopyButton.vue";
import {useStore} from "vuex";
import InvoiceDTO from "@/models/InvoiceDTO";
import InvoiceDealDTO from "@/models/InvoiceDealDTO";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import InvoiceDealsRequestDTO from "@/models/request/InvoiceDealsRequestDTO";
import {DealStatus} from "@/models/enum/DealStatus";
import InvoiceDetailsTable from "@/components/InvoiceDetailsTable.vue";
import InvoiceDealDetailsTable from "@/components/InvoiceDealDetailsTable.vue";

const api = new APIClient();

export default defineComponent({
  components: {
    LoaderWrapper,
    CopyButton,
    InvoiceDetailsTable,
    InvoiceDealDetailsTable,
  },
  props: {
    invoice: {
      type: Object as PropType<InvoiceDTO>,
      default: null
    } as Prop<InvoiceDTO>
  },
  setup(props) {
    const store = useStore()

    helper.initCopyHints();

    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)

    const state = reactive({
      page: 1,
      deals: {
        limit: 100,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<InvoiceDealDTO>
    });

    watch(() => props.invoice, async () => {
      state.deals = {
        limit: 100,
        offset: 0,
        totalCount: 0,
        items: []
      };
      if (!props.invoice) {
        return;
      }

      loader.value?.show()
      state.deals = await api.invoiceDeals(state.deals, {createdAt: 'DESC'}, {invoiceId: props.invoice?.id} as InvoiceDealsRequestDTO);
      loader.value?.hide()
    })



    return {
      ...toRefs(state),
      loader,
      dateHelper,
      numberFormatter,
      DealStatus,
      helper
    }
  }
})
</script>
